import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { TabsMethods } from './helpers/TabsMethods';
import { ListenerAction } from './helpers/types';
import { useGetTranslations } from '~/composables/useGetTranslations';
import AzButton from '~/components/_next/atoms/AzButton.vue';
export default defineComponent({
  name: 'TheTabs',
  props: {
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isPreferenciesBtnShown: {
      type: Boolean,
      default: false
    },
    scrollToTabIndex: {
      type: Number,
      default: 2
    }
  },
  components: {
    TheTabSection: function TheTabSection() {
      return import('./TheTabSection.vue');
    },
    AzButton: AzButton
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var tabs = computed(function () {
      return props.tabs.filter(function (tab) {
        return (tab === null || tab === void 0 ? void 0 : tab.fields) !== undefined;
      });
    });
    var tabsTitles = computed(function () {
      return tabs.value.map(function (tab) {
        var _tab$fields;
        return (_tab$fields = tab.fields) === null || _tab$fields === void 0 ? void 0 : _tab$fields.title;
      }).filter(function (tab) {
        return tab !== undefined;
      });
    });
    var currentActiveTab = ref(tabsTitles.value[0]);
    var areTabsActive = computed(function () {
      return tabsTitles.value[0];
    });
    var tabContainerRef = ref(null);
    var tabSectionsRef = ref(null);
    var tabWrapperRef = ref(null);
    var tabsData = reactive({
      tabs: tabs,
      tabsTitles: tabsTitles,
      currentActiveTab: currentActiveTab,
      tabContainerRef: tabContainerRef,
      tabSectionsRef: tabSectionsRef,
      tabWrapperRef: tabWrapperRef
    });
    var tabsMethods = TabsMethods(tabsData);
    onMounted(function () {
      tabsMethods.handleListeners(ListenerAction.add);
    });
    onBeforeUnmount(function () {
      tabsMethods.handleListeners(ListenerAction.remove);
    });
    return {
      scrollToSection: tabsMethods.scrollToProperSection,
      currentActiveTab: currentActiveTab,
      areTabsActive: areTabsActive,
      tabsTitles: tabsTitles,
      tabContainerRef: tabContainerRef,
      tabSectionsRef: tabSectionsRef,
      tabWrapperRef: tabWrapperRef,
      lastTabContentsLastElement: tabsMethods.lastTabContentsLastElement,
      translate: translate
    };
  }
});